import { slugifyItalian } from '../../idGenerator';

export function sectionId(label: string): string {
  return `sec_${slugifyItalian(label)}`;
}
